<template>
  <div class="home fx-fs-c-c">
    <div class="back-wrapper">
      <a
        href="https://www.xuezhangmen.com"
        target="_blank"
        class="back-xuezhangmen"
      >
        <img src="../assets/icon-back.png" alt="" />
        <span>返回学掌门</span>
      </a>
    </div>
    <img
      width="100%"
      src="../assets/banner.png"
      alt=""
      style="
        min-width: 1200px;
        height: 633px;
        object-fit: cover;
        object-position: center;
      "
    />
    <div class="ywgcsdy fx-fs-c">
      <img width="287px" src="../assets/dy.png" alt="" />
      <div class="fx-c-fs-c">
        <p class="tit">运维工程师的定义</p>
        <p class="desc">
          运维工程师是指负责互联网系统运营、实施和维护的职位，也称作运维人员或运维实施人员。在互联网相关产业中，运维工程师是一个关键且不可或缺的职位，不仅需要深入了解企业的业务流程和IT架构，还要通过监控、分析、维护和优化来确保系统的可靠性和安全性，作用非常大。
        </p>
      </div>
    </div>
    <div class="fx-c-c tit-moudle">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">运维工程师的主要职责</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <div class="ywgcszz fx-sb-c">
      <div class="item" v-for="item in respons" :key="item.name">
        <img :src="item.img" alt="" />
        <p class="con" v-html="item.name"></p>
      </div>
    </div>
    <div class="linux fx-fs-c-c">
      <div class="fx-c-c tit-moudle">
        <img src="../assets/tit-icon.png" alt="" />
        <p class="tit">运维工程师重要的技能一Linux</p>
        <img src="../assets/tit-icon.png" alt="" />
      </div>
      <div class="linux-con fx-sb-c">
        <div class="shu"></div>
        <div class="con">
          <p class="desc">
            Linux是一款开放源代码的计算机操作系统，被视为世界上最成功的自由软件之一，广泛应用于服务器环境和嵌入式设备中。当下，大多数应用都是跑在Linux平台上，就连我们用的安卓手机底层也是Linux架构。
          </p>
          <p class="tip">
            这些领域都离不开Linux： 互联网 电子商务 通信 金融 教育 机械制造 军工
            航天
          </p>
        </div>
        <div class="zytd">
          <div class="tip">linux主要特点</div>
          <div class="item-box fx-fs-c">
            <div class="item fx-fs-c">
              <img src="../assets/gou.png" alt="" />
              <span class="name">开放源代码</span>
            </div>
            <div class="item fx-fs-c">
              <img src="../assets/gou.png" alt="" />
              <span class="name">多任务和用户支持</span>
            </div>
            <div class="item fx-fs-c">
              <img src="../assets/gou.png" alt="" />
              <span class="name">稳定性和可靠性</span>
            </div>
            <div class="item fx-fs-c">
              <img src="../assets/gou.png" alt="" />
              <span class="name">安全性</span>
            </div>
            <div class="item fx-fs-c">
              <img src="../assets/gou.png" alt="" />
              <span class="name">灵活性</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="fx-c-c tit-moudle" style="margin: 88px 0 99px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">运维工程师进阶技能一云计算</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <div class="yjs fx-sb-c">
      <div class="zytd">
        <div class="tip">云计算主要特点</div>
        <div class="item-box fx-fs-c">
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">弹性伸缩性</span>
          </div>
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">自助服务性</span>
          </div>
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">经济性</span>
          </div>
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">资源池化</span>
          </div>
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">可靠性</span>
          </div>
          <div class="item fx-fs-c">
            <img src="../assets/gou.png" alt="" />
            <span class="name">高可扩展性</span>
          </div>
        </div>
      </div>
      <div class="desc">
        2022年11月底，ChatGPT一经推出，就迅速在社交媒体上走红，短短2个月，注册用户数突破1亿，成为史上增长最快的消费者应用，并在全球范围内掀起了一阵“人工智能”热潮。其实，ChatGPT依托的核心技术之一就是云计算。打个比方，ChatGPT如果是一个“数字生命体”，那么云计算就是它的“中枢神经”。
      </div>
      <div class="shu"></div>
    </div>
    <div class="fx-c-c tit-moudle" style="margin: 111px 0 34px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">运维工程师迎战AI时代的利剑</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <div class="lijian">
      2023年，ChatGPT席卷全球，广泛的应用场景和高效的内容生成，令各行各业“为之疯狂”，职场人不禁彷徨:我会被替代吗?为助力学员赢战人工智能时代，学掌门重磅推出运维工程师就业课程，致力于让每名学员都能高效运用AI完成运维和实施工作。
    </div>
    <div class="tedian">Linux云计算运维工程师的主要特点</div>
    <img src="../assets/td.png" alt="" />
    <div class="xzsp fx-fs-c-c">
      <p class="tit">Linux云计算运维的就业方向和薪资水平</p>
      <p class="tip">
        云计算是当前IT行业热门领域之一，随着云计算市场的不断扩大，云计算相关岗位需求也在不断增加,就业方向主要包括以下几个岗位:
      </p>
      <div class="fx-c-c">
        <img class="chart" src="../assets/chart.png" alt="" />
        <img class="xzsp-img" src="../assets/xzsp.png" alt="" />
      </div>
      p
      <p class="jjlx">Linux云计算运维的职业进阶路线</p>
      <div class="jsx-box fx-fe-c">
        <div class="jsx">技术线</div>
        <div class="jsx-in fx-fs-c">
          <div class="item">软件实施工程师</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">自动化运维工程师</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">云平台运维工程师</div>
          <div class="item">数据库工程师</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">运维开发工程师</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">运维平台研发工程师</div>
        </div>
      </div>
      <div class="cpx-box fx-fe-c">
        <div class="jsx">产品线</div>
        <div class="jsx-in fx-fs-c">
          <div class="item">产品运营</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">高级产品运营经理</div>
          <img class="arrow" src="../assets/arrow.png" alt="" />
          <div class="item">产品总监</div>
        </div>
      </div>
    </div>
    <div class="fx-c-c tit-moudle" style="margin: 69px 0 46px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">课程特色</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <div class="zpyq fx-fs-c-c">
      <p class="tit">课程充分调研用人企业招聘要求</p>
      <p class="desc">
        目前，企业对于软件运维人员和实施人员，已经不是停留在Linux命令、数据库使用、会进行软件产品的部署这样的基本操作了，而是需要熟练自动化运维工具的使用、分布式中间件产品的部署、应用容器镜像制作、云平台微服务应用编排、系统监控和虚拟化平台的合适人选。
      </p>
      <p class="desc" style="margin-top: 22px">
        这对软件运维和实施人员的技术储备和知识面，提出了更高的要求。学掌门的课程正是在充分调研用人企业招聘需求后，对上述技术进行精心设计后的产物，可以让学员能够胜任企业的需求。
      </p>
    </div>

    <div
      class="fx-fs-c-c"
      style="width: 1200px; height: 478px; background: #f2f4fc"
    >
      <p class="jsjj">6大阶段式学习+4大前沿技术精讲</p>
      <div class="jj-box">
        <div class="jieduan fx-fs-c">
          <div class="item fx-fs-c">
            <div class="num">阶段一</div>
            <p class="desc">Linux操作系统(17天)</p>
          </div>
          <div class="item fx-fs-c">
            <div class="num">阶段二</div>
            <p class="desc">数据库 (7天)</p>
          </div>
        </div>
        <div class="jieduan fx-fs-c" style="background: #f7f8ff">
          <div class="item fx-fs-c">
            <div class="num">阶段三</div>
            <p class="desc">Python自动化运维 (6天)</p>
          </div>
          <div class="item fx-fs-c">
            <div class="num">阶段四</div>
            <p class="desc">自动化运维 (10天)</p>
          </div>
        </div>
        <div class="jieduan fx-fs-c">
          <div class="item fx-fs-c">
            <div class="num">阶段五</div>
            <p class="desc">分布式和微服务(23天)</p>
          </div>
          <div class="item fx-fs-c">
            <div class="num">阶段六</div>
            <p class="desc">系统监控和虚拟化 (20天)</p>
          </div>
        </div>
        <div class="jieduan fx-fs-c jieduan1">
          <div class="item fx-fs-c" style="padding-left: 78px">
            <img width="40px" src="../assets/01.png" alt="" />
            <p class="desc">Vmware vSphere 虚拟化平台精讲</p>
          </div>
          <div class="item fx-fs-c" style="padding-left: 78px">
            <img width="40px" src="../assets/02.png" alt="" />
            <p class="desc">Zabbix 系统监控精讲</p>
          </div>
        </div>
        <div class="jieduan fx-fs-c jieduan1">
          <div class="item fx-fs-c" style="padding-left: 78px">
            <img width="40px" src="../assets/03.png" alt="" />
            <p class="desc">ELK数据采集、数据分析、日志追踪精讲</p>
          </div>
          <div class="item fx-fs-c" style="padding-left: 78px">
            <img width="40px" src="../assets/04.png" alt="" />
            <p class="desc">Oracle数据库精讲</p>
          </div>
        </div>
      </div>
    </div>
    <div class="fx-c-c tit-moudle" style="margin: 83px 0 30px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">案例驱动学习法，还原企业真实研发场景</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <p class="yfcj">
      学掌门的Linux云计算课程为每一个技术点精心设计典型的、易于理解的案例场景，先演示场景，再与学生互动解决思路、解决方案，最后操作实现方案。避免脱离业务场景的纯理论学习和照本宣科。
    </p>
    <img
      width="871px"
      style="margin-top: 45px"
      src="../assets/yfcj.png"
      alt=""
    />
    <div class="fx-c-c tit-moudle" style="margin: 119px 0 30px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">定制化培养，学员服务一步到位</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <!-- <p class="ybdw">
      学掌门的Linux云计算课程为每一个技术点精心设计典型的、易于理解的案例场景，先演示场景，再与学生互动解决思路、解决方案，最后操作实现方案。避免脱离业务场景的纯理论学习和照本宣科。
    </p> -->
    <img
      width="850px"
      style="margin-top: 8px"
      src="../assets/ybdw.png"
      alt=""
    />
    <div class="xxypt fx-fs-c-c">
      <div class="fx-c-c tit-moudle" style="margin: 51px 0 70px">
        <img src="../assets/tit-icon.png" alt="" />
        <p class="tit">学掌门AtStudy学习云平台</p>
        <img src="../assets/tit-icon.png" alt="" />
      </div>
      <img
        width="950px"
        style="margin-top: 8px"
        src="../assets/ypt.png"
        alt=""
      />
    </div>
    <div class="kcdg fx-fs-c-c">
      <div class="fx-c-c tit-moudle" style="margin: 81px 0 60px">
        <img src="../assets/tit-icon.png" alt="" />
        <p class="tit" style="color: #fff">课程大纲</p>
        <img src="../assets/tit-icon.png" alt="" />
      </div>
      <div class="dg-con fx-fs-c">
        <div class="jieduan">
          <div
            class="item fx-c-fs-c"
            :class="{ act: jdIndex == index }"
            v-for="(item, index) in kcdg"
            :key="item.name"
            @click="jdChange(index)"
          >
            <div class="num">{{ item.jd }}</div>
            <p class="name">{{ item.name }}</p>
          </div>
        </div>
        <div class="con" ref="jdCon">
          <p class="mb-tit">培训目标</p>
          <p class="mb-desc" v-html="kcdg[jdIndex].more.target"></p>
          <div v-for="item in kcdg[jdIndex].more.detail" :key="item.name">
            <div class="c-name">{{ item.name }}</div>
            <p class="detail" v-for="(itemIn, index) in item.list" :key="index">
              {{ itemIn }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="fx-c-c tit-moudle" style="margin: 81px 0 60px">
      <img src="../assets/tit-icon.png" alt="" />
      <p class="tit">合作企业</p>
      <img src="../assets/tit-icon.png" alt="" />
    </div>
    <img
      width="1186px"
      style="margin-top: 8px"
      src="../assets/hzqy.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  name: 'Home',
  // metaInfo: {
  //   title: 'Linux云计算运维工程师就业培训课程-学掌门Atstudy网校',
  //   meta: [
  //     {
  //       name: 'keywords',
  //       content:
  //         'Linux云计算培训课程,Linux操作系统,数据库,分布式和微服务,Python自动化运维,软件实施工程师,数据库工程师,自动化运维工程师,学掌门Atstudy网校,就业培训'
  //     },
  //     {
  //       name: 'description',
  //       content:
  //         '学掌门的Linux云计算课程为每一个技术点精心设计典型的、易于理解的案例场景，先演示场景，再与学生互动解决思路、解决方案，最后操作实现方案。避免脱离业务场景的纯理论学习和照本宣科。'
  //     }
  //   ]
  // },
  components: {},
  data() {
    return {
      jdIndex: 0,
      respons: [
        {
          img: require('../assets/zz1.png'),
          name: '监控<br/>系统和网站'
        },
        {
          img: require('../assets/zz2.png'),
          name: '确保<br/>系统稳定性'
        },
        {
          img: require('../assets/zz3.png'),
          name: '故障处理'
        },
        {
          img: require('../assets/zz4.png'),
          name: '灾难保障'
        },
        {
          img: require('../assets/zz5.png'),
          name: '安全恢复'
        },
        {
          img: require('../assets/zz6.png'),
          name: '文档撰写'
        }
      ],
      kcdg: [
        {
          jd: '阶段一',
          name: 'Linux操作系统 (21天)',
          more: {
            target:
              '1：熟练掌握Linux常用命令、文件管理、用户组管理、权限管理、编辑器使用。<br/>2：熟练掌握Linux虚拟化技术、磁盘分区、阵列、热备、网络模式、各类工具的使用。<br/>3：熟练掌握在Linux环境下部署软件的生产环境、集群化部署方案、持续集成。',
            detail: [
              {
                name: 'Linux核心(3天）',
                list: [
                  'Linux发展史、Vmware安装MobaXterm安装部署Centos7的镜像',
                  'Vmware-桥接模式、NAT模式仅主机模式克隆虚拟主机、快照、MoBaXterm连接虚拟机',
                  'Linux操作系统启动流程讲解、Linux系统目录功能讲解',
                  'VIM-工作模式、基本应用、进阶应用、命令总结',
                  '主机名配置、帮助命令目录操作、文件操作操作目录、权限命令、进程管理、压缩和解压缩',
                  '系统监视概述top命令mpstat命令、vmstat命令iostat命令、新能分析标准运维小细节',
                  'Linux软件包－软件包的特点、源码包的特点、二进制包的特点、RPM包的安装与升级、RPM包的查询、RPM包的卸载RPM包的校验与数字证书、RPM包的文件提取',
                  'YUM -工作原理企业案例、优先级配置、构建YUM本地源构建YUM网络源、同步外网YUM源',
                  '特性及组件、单元类型、单元的配置文件语法、相关工具',
                  'root密码－单用户模式修改root密码、救援模式修改root密码、破解root密码',
                  'Linux用户管理－用户命令汇总、skel目录详解、login.defs配置文件详解、useradd文件详解、与用户相关的文件',
                  'Linux用户管理－用户组命令groupadd、密码相关命令passwd、修改用户密码有效期、删除用户、删除用户组、用户查询',
                  'Linu对又限－数字权限、字母权限、chown属主和属组管理、特殊权限SUID SGIDSBIT详解、ALC权限设置',
                  'Linux身份-身份切换命令su、sudo、企业生产环境用户权限集中管理方案',
                  '磁盘分区简介主分区、扩展分区和逻辑分区、swap交换分区',
                  '场景介绍、LVM逻辑创建XFS格式扩容 ext4格式扩容、LVM逻辑卷删除',
                  '列介绍创建模拟损坏阵列、奇偶校验和热备盘创建'
                ]
              },
              {
                name: 'Linux虚拟化(5天）',
                list: [
                  '服务搭建映射、服务补充',
                  'ftp模式介绍、vsftpd匿名用户模式配置、vsftpd本地用户模式配置、用户列表管控',
                  '服务部署、写入权限问题的解决方案开机自动挂载',
                  'NTP时间服务介绍及部署、 定时同步及同步外网',
                  '工作原理介绍、服务部署使用详解',
                  'cobbler自动化安装系统使用详解、cobbler实现安装不同操作系统',
                  '配置文件详解、反向代理、负载均衡、LNMP架构动态上线',
                  'tomcat启动和关闭、多实例部署、集群搭建、上线动态网站',
                  'GPT生成服务器配置文件',
                  'GPT生成服务器配置文件模拟Nginx,自动化部署',
                  'GPT模拟Tomcat,自动化部署'
                ]
              },
              {
                name: 'Linux网络与服务(6天*4小时）',
                list: [
                  '网络协议、路由器、交换机、VLAN虚拟局域网、IP地址、Mac地址、Port端口',
                  '网络状态管理网络通讯、静态路由、动态路由',
                  '日志管理系统日志、Rsyslog日志、Logrotate日志轮转',
                  '计划任务、Crontab使用、SSH远程连接服务、SSH加密认证',
                  'Samba服务搭建、Samba映射、Samba服务操作',
                  'FTP模式、VsFtpd匿名用户模式、VsFtpd本地用户模式、用户列表管控',
                  'NFS服务部署、NFS服务写入权限、NFS开机自动挂载',
                  'NTP时间服务部署NTP定时同步NTP同步外网',
                  'DHCP服务部署DHCP服务操作',
                  'Cobbler自动化安装Cobbler安装各类操作系统',
                  'Nginx搭建、Nginx配置Nginx反向代理Ngin焕载均衡',
                  'LNMP生产环境搭建、LNMP产品上线',
                  'Tomcat搭建与配置Tomcat多实例部署Tomcat集群部署Tomcat产品上线',
                  '域名申请域名备案、域名解析、DNS客户端测试工具'
                ]
              },
              {
                name: 'Linux Shell(3天*4小时）',
                list: [
                  'shell介绍grep、cut、sort、uniq、seq、tr等命令用法详解',
                  '变量介绍变量的使用',
                  '条件表达式if条件判断、if嵌套',
                  'for循环语句详解、while循环语句详解、break和continue用法讲解',
                  'shell函数介绍、基础正则和扩展正则详解、sed用法详解 awk用法详解',
                  'GPT生成相应的Shell功能脚本',
                  'GPT检查Shell脚本规范'
                ]
              },
              {
                name: 'Linux部署与负载(2天）',
                list: [
                  '插件安装、安装部署、凭证创建及使用说明、项目简单演示',
                  'iptables常用使用详解、SNAT的使用、DNAT的使用',
                  'LVS负载均衡使用详解',
                  'keepalived介绍、配置、使用演示、nginx + KeepAlived使用演示',
                  'GPT监控LVS负载情况',
                  'GPT生成Jenkins配置文档'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段二',
          name: '数据库（9天）',
          more: {
            target:
              '1：熟练使用MySQL数据库产品的DCL、DDL、DML、DQL操作。<br/>2：熟练使用Oracle数据库产品的DCL、DDL、DML、DQL操作。<br/>3：熟练掌握各类数据库产品的主从部署方案、主从复制、主从同步、读写分离技术。',
            detail: [
              {
                name: 'MySQL数据库(5天*4小时）',
                list: [
                  'MySql8的安装与初始化过程后期设置与简单操作 MySqlS.7安装与初始化后期设置与简单操作场景介绍、mysqldump、tar与cp、xtrabackup、mysqlbackup',
                  '主从复制概念与常见拓扑结构、主从复制的同步方式、环境准备过程、复制常用参数、配置操作演示',
                  'MyCat产品特性与功能介绍、安装与启动、读写分离配置过程',
                  'MySql数据库Sql基础介绍、创建与常规操作、类型与日期、表的创建与管理、表的增删改查',
                  'GPT自动生成MySql备份，自动恢复',
                  'GPT自动生成Sql操作语句'
                ]
              },
              {
                name: 'Oracle数据库(4天*4小时）',
                list: [
                  'Oracle版本介绍Oracle安装、物理结构、逻辑结构、SGA、PGA、进程',
                  'Oracle数据库实例管理、Oracle参数文件管理、Oracle控制文件管理',
                  'Oracle重做日志Oracle归档模式Oracle表空间Oracle数据文件',
                  'Oracle用户管理、Oracle网络监听配置OracleEM管理工具',
                  'Oracle备份与恢复Oracle日常检查故障分析、性能优化',
                  'Oracle数据库集群容灾高可用技术、Oracle项目实战'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段三',
          name: 'python自动化运维（10天）',
          more: {
            target:
              '1：熟练掌握Python编程语言，培养扎实、规范的Python编码功底。<br/>2：熟练各类Python数据处理方式，生成各类结构数据报表。<br/>3：熟练使用Python爬虫技术、Selenium自动化工具。',
            detail: [
              {
                name: 'Python敏捷编程(3天*4小时）',
                list: [
                  'Python3下载安装，pycharm的安装、第—个Python程序、Python中的变温',
                  '基础数据类型、转换、运算',
                  '列表多元素的提取、添加、修改、删除、字典的操作详解',
                  '基本的逻辑控制语句if_else',
                  'for循环遍历和操作列表、continue和break',
                  '函数的创建和调用、函数内局部变量、全局变量使用技巧',
                  '列表字典字符串、数字类型的相互转换'
                ]
              },
              {
                name: 'Python数据猎人(7天*4小时）',
                list: [
                  '安装使用结巴分词',
                  '正则表达式详解',
                  '通过结巴、计数器对报告进行词频统计',
                  '词频统计生成词云图片',
                  '熊猫处理Excel实例详解',
                  '熊猫处理全僵数据－列表生成',
                  '熊猫处理全量数据生成DataFrame',
                  '熊猫处理全量数据操作分组数据',
                  'Python使用Openpyx操作Excel数据详解',
                  'Python使用Pyecharts制作统计图详解',
                  'Python爬虫详解、实际操作演示、自动化Selenium操作详解',
                  'GPT模拟结巴分词 提取相关数据',
                  'GPT模拟熊猫数据框架对数据进行分析',
                  'GPT模拟爬虫获取网络数据',
                  'GPT模拟Selenium自动化操作'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段四',
          name: '自动化运维（12天）',
          more: {
            target:
              '1：熟练棠握Ansible常用命令、AdHoc语法、Playbook语法、Playbook集群部署方案。<br/>2：熟练掌握Ansible对各类常用产品的部署方案及配置信息。<br/>3：熟练掌握Ansible-Role部署集群环境、基础模块、应用模块、业务引入。',
            detail: [
              {
                name: 'Ansible',
                list: [
                  '场景介绍、功能特性基础架构、安装、配置文件介绍、配置文件优先级、inventory基本应用、实战用户管理被控端',
                  '命令语法、执行流程状态、配置场景、常用模块说明',
                  'command、yum copy、systemd、file、 group、User、Mount、cron、get_url、Unarchive',
                  '基本介绍、与AD-HOC的区别、管理NFS服务、管理Rsync服务端、管理Rsync客户端',
                  '项目环境准备管理Redis服务Nginx负载均衡升级Nginxt办议、替换Nginx为Haprox',
                  'Variables变量介绍、定义方式、Playbook定义变量、inventory;清单文件定义变量、host-vars定义变量、group-vars定义变量外置传递参数定义变量变量优先级、NFS改造为变量方式',
                  '场景介绍、变量语法示例、基于IP生成Redis配置、基千CPU生成Nginx配置、基于内存生成Memcache配置、优化－关闭facts、优化-redis缓存',
                  'Register-获取被控端端口信息批量修改主机名称、创建JMS相关ke 、',
                  'when、loop、Hadlers Include部署Tom、ignore_errors、forec_handlers、changed_when、vault',
                  '场景介绍、生成Nginx配置、生成haproxy配置、判断生成Keepalived',
                  '场景介绍、编排NFS服务、编排Rsync服务、部署集群环境架构图、服务器整体规划、基础环境准备、网络配詈初始化、防火墙管理、用户管理、yum仓库管理、基础软件包管理、文件描述符管理、内核模块管理、模块测试',
                  'NFS服务、Mysql服务、Redis服务、Nginx服务、PHP服务、Haproxy服务、KeepAlived服务、LVS服务、Route服务、DNS服务、Wordpress-web、Wrodpress-prox、Wordpress-keep、Wordpress-LVS'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段五',
          name: '分布式和微服务（26天）',
          more: {
            target:
              '1：熟练掌握Redis的持久化配置缓存淘汰配置、各类部署方案，主流MQ消息队列产品的集群化部署配置。<br/> 2：熟练掌握ELK工具的数据采集、数据分析、日志追踪方案。<br/>3：熟练掌握Docker应用容器镜像的制作、K8S运用。',
            detail: [
              {
                name: 'Redis(2天）',
                list: [
                  'Redis安装及配置、Redis适用场景、Redis持久化机制',
                  'Redis过期删除策略、Redis缓存淘汰策略',
                  'Redis主从部署方案RedisSentine哨兵部署方案、RedisCluste集群部署方案'
                ]
              },
              {
                name: 'ELK数据采集分析(12天*4小时）',
                list: [
                  '没有日志分析工具存在的痛点、ELK基础架构解析、ELFK基础架构解析',
                  '安装、配置、调试、相关属于、文档、索引、字段、操作Curl、操作Kibana、索引API',
                  '基本概念、环境搭建、状态检查Curl、Cerebra、角色、分片与副本、故障转移、文档路由、创建流程、扩展Data节点、扩展路由节点、内核优化、配置优化、JVM优化',
                  'FileBeat-基本概念、配置解读、基本应用、写入数据到ES集群、定义索引名称、设置分片副本、系统日志、字段处理收集nginx访问日志普通格式、json格式、错误日志、多虚拟主机日志、手机-tomcat访问日志、错误日志、多虚拟主机tomcat节点日志',
                  'Logstash-日志处理基本介绍基础架构、安装与配置',
                  'Logstash-插件-Input插件、filter-grok插件、filter-geoip插件、filter-date插件、filter-useragen插件、filter-mutate插件',
                  'App业务日志-Filebeat配置Logstash配置、Kibana配詈、Nginx日志－介绍、logstash配置、Filebeat配置、Nginx-Kibana展示Mysql慢日志介绍、Filebeat配置、Logstash配置、Kibana展示',
                  'Kibanan-日志分析基本架构、指标说明日志用例、指标数据图、水平条形图标签云、时间序列、图形汇聚访问控制－基于Ngxin、基于RBAC',
                  '引入消息队列、解决耦合度问题、解决性能问题、引入Redis-Filebeat配置、Logstash配置',
                  '日志告警ElastAlert环境准备、ElastAlert接入钉钉、404告警场景、延迟告警场景',
                  'GPT模拟Zookeepe滇群部署',
                  'GPT模拟Kafka-eagle监控',
                  'GPT模拟ElastAlert环境部署404告警'
                ]
              },
              {
                name: 'MQ消息队列(2天）',
                list: [
                  'MQ-基本概念、分类、使用场景介绍、异步',
                  'MQ-kafka基本概念、基本架构、安装与调试、模拟生产者和消费者、单播消费者模拟',
                  'MQ-kafka-集群-Zookeeper集群部署',
                  'MQ-kafka-集群-kafka-eagle安装、kafka-eagle监控JVM、集群容错验证'
                ]
              },
              {
                name: 'Docker应用容器(7天*4小时）',
                list: [
                  '简介、功能特性与应用场景',
                  '安装标准安装、CE安装、更改默认数据目录',
                  'attach、build、commit、cp、create、diff、events、exec、export、history、images、import、info、inspect、kill、load、login、logout、logs、pause、port、ps、pull and push、rename、restart、rm、rmi、run、save、search、start、starts、stop、tag、top、update、version and wait',
                  'config、container、image、node plugin se、service、指令介绍',
                  '镜像制作-Dockfile编写官方镜像库的使用、Centos 7镜像制作与运行、基于Alpine的JRE和Tomcat镜像制作与运行、MySQLS.6镜像制作与运行、Redis镜像制作与运行、MongoDB镜像制作与运行',
                  '私有镜像Harbor简介、使用DNSMASQ快速搭建DNS服务签发域名证书、信任自签发的域名证书、Harbor1.4版本配置与安装漏洞扫描和镜像签名、镜像复制与同步',
                  '环境准备修改配置启动Harbor、Keepalived安装与配置OpenLDAP安装与配置OpenLDAP创建组织架构与Harbor',
                  '场景介绍、环境准备安装与磁盘准备repo替换、Ceph安装与配置创建存储池和文件系统挂在cephfs文件系统 Ceph集群扩容、集群增加节点和OSD'
                ]
              },
              {
                name: 'K8S容器分布式架构(3天）',
                list: [
                  'K8S-概念-K8S应用领域、K8S的优势K8S架构、K8S工作节点组件介绍、K8S核心资源介绍',
                  'K8S-kubeadm-实现环境规划、配置IP和主机名、配置防火墙和Yum源、配置ipvs',
                  'K8S集群安装和配置Docker、准备K8S命令行工具、配置Keepalived和nginx、初始化集群、扩容K8S添加Master节点添加Node节点',
                  'K8S-安装和调试－安装calico网络插件、调试K8S集群网络、部署业务pod、coredns域名解析'
                ]
              }
            ]
          }
        },
        {
          jd: '阶段六',
          name: '系统监控和虚拟化（18天）',
          more: {
            target:
              '1：熟练使用Zabbix系统监控、自动报警、自定义宏、故障自动处理，掌握分布式监控部署方案。<br/>2：熟练使用KVM网络配置、迁徙方案、各类集群化部署方案、嵌套虚拟化方案、备份与恢复方案。<br/>3：熟练掌握VmwarevSphere虚拟化平台角色和权限、备份还原与监控、模板克隆和快照的使用。',
            detail: [
              {
                name: 'Zabbix系统监控(5天*4小时）',
                list: [
                  'Zabbix版本介绍、server的安装、配置、调试',
                  'Zabbix配置MariaDB',
                  'Zabbix安装WebGUI、GUI界面初始化、自定义监控模板',
                  'Zabbix监控Linux用户账号和密码、自定义Triggers、自定义Discovery',
                  'Zabbix监控Nginx+FPM、软链接、监控自动化工具',
                  'Zabbix-Server配置参数的详解、高级参数详解、Screen',
                  'Zabbix监控邮件系统、邮件自动报警、使用Python自动脚本、邮件报警演示',
                  'Zabbix宏定义、开机自启动、自定义宏讲解、宏补充及Agent配詈',
                  'Zabbix自定义监控接口讲解、自定义监控接口参数演示',
                  'Zabbix监控故障自动处理、执行命令、Ansible批量部署',
                  'Zabbix分布式监控讲解、演示、性能优化',
                  'Zabbix源码编译-MySQL/Agent、安装Server、DB配置、Prox和Ansible批量开机自启',
                  'Zabbix-HOS下部署ZabbixAgent、results register、HOST批量创建、信息获取、templates、Ansible Role演示',
                  'GPT生成Zabbix-Server的配置文件',
                  'GPT模拟Zabbix-Server监控邮件，自动报警'
                ]
              },
              {
                name: 'KVM 虚拟化(7天*4小时）',
                list: [
                  '配置网卡、配置Lan、配置网络过滤、迁徙概述、静态迁移、共享存储的动态迁移、本地存储的动态迁移',
                  'P2V和V2V迁徙方案概述、准备宿主机、物理机迁徙到虚拟机、虚拟机迁徙到物理机',
                  'HA群集-Pacemaker + Corosync的Ha体系结构',
                  '群集安装-规划设计、组件安装、就群集节点准备、群集的创建',
                  'NFS群集-规划设计、NFS服务器配置与迁徙、创建高可用虚拟机、配置STONITH (IPMI)',
                  'ISCSI群集-规划设计、配置ISCSI Target、配置STONITH(DISK)、配置DLM、配置CLVM、群集添加',
                  'DRBD群集-规划设计、DRBD安装与配置、双祝DRBD资源准备、配置STONITH (virtd) 、配置DLM、配置CLVM、配置GFS2、群集添加',
                  '嵌套虚拟化-原理详解、KVMS上运行KVM与ESXI、KVM运行Hyper-V',
                  '概述、Guest Agent与快照原理、virt-manager管理快照、virsh管理快照、KVM备份与恢复备份脚本',
                  'RHEL/Centos7的KVM性能特性和改进virt-manager中的性能管理、网络性能优化、存储性能优化、内存与CPU性能优化',
                  '场景介绍、部署要求、引擎安装、安装Centos7节点、安装oVirtNode节点、配詈数据中心、配詈数据及ISO域、创建Windows虚拟机、 创建Linux虚拟机及配置Ovirt Agent、上传已有KVM镜像、使用模板、角色及权限管理、备份与恢复'
                ]
              },
              {
                name: 'Vmware vSphere虚拟化平台(6天*4小时）',
                list: [
                  'vSphere-概述、资源虚拟化、ESXI概述',
                  'vSphere-虚拟机、虚拟机硬件、容器部署Storage',
                  'vSphere-vCenter-使用vCenterServe进行集中管理、部署vCenterServer、vCenterServer; 清单、角色和权限、备份还原与监控vCenter Server HA ',
                  'vSphere虚拟网络管理-标准交换机、网络策略与分布式交换机',
                  'vSphere虚拟内存管理-虚拟存储、添加ISCSI存储、vmfs与NFS数据存储',
                  'vSphere-虚拟机管理-创建模板和克隆、内容库、修改虚拟机、vMotion、EVC、StoragevMotion与快照',
                  'vSphere-资源管理-CPU、内存资源控制、资源监控工具、监控资源情况、使用报警',
                  'vSphere集群-详情介绍、DRS理论、HAJ里论、配置HA、配置FT',
                  'vSphere-生命周期管理',
                  'GPT部署vSphere-vCenter',
                  'GPT模拟vSphere-vCenter备份与监控',
                  'GPT模拟vSphere报警'
                ]
              }
            ]
          }
        }
      ]
    }
  },
  methods: {
    jdChange(i) {
      this.jdIndex = i
      let that = this
      this.$nextTick(() => {
        that.$refs.jdCon.scrollTop = 0
      })
    }
  }
}
</script>
<style scoped lang="scss">
$width: 1200px;
.home {
  position: relative;
}
.back-wrapper {
  position: relative;
  width: 1200px;
  height: 0;
  margin: 0 auto;
}
.back-xuezhangmen {
  position: absolute;
  top: 56px;
  left: -150px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 149px;
  height: 41px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 21px;
  text-decoration: none !important;
  cursor: pointer;
  img {
    width: 9px;
    height: 15px;
    margin-right: 10px;
  }
  span {
    font-family: Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #fcfcff !important;
  }
}
.ywgcsdy {
  width: 1200px;
  height: 200px;
  background: #e6efff;
  box-shadow: 0px 2px 8px 0px rgba(100, 126, 246, 0.49);
  border-radius: 100px;
  margin: 25px 0 81px;
  .tit {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4141ca;
    line-height: 30px;
    margin-bottom: 16px;
  }
  .desc {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3e3e3e;
    line-height: 30px;
  }
}
.tit-moudle {
  .tit {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #4141ca;
    line-height: 30px;
    margin: 0 45px;
  }
}
.ywgcszz {
  width: $width;
  margin: 43px 0 38px;
  flex-wrap: wrap;
  .item {
    width: 380px;
    height: 116.9px;
    margin-bottom: 34px;
    position: relative;
    .con {
      position: absolute;
      top: 50%;
      left: 39px;
      transform: translateY(-50%);
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fefefe;
      line-height: 36px;
    }
  }
}
.linux,
.yjs {
  width: 100%;
  height: 560px;
  background: #dcecf9;
  padding-top: 78px;
  .linux-con {
    width: 1199px;
    height: 260px;
    background: #f6fafe;
    border-radius: 30px;
    margin-top: 99px;
    padding: 0 21px 0 60px;
    position: relative;
    .shu {
      position: absolute;
      left: 29px;
      top: 45px;
      width: 4px;
      height: 180px;
      background: linear-gradient(0deg, #e7fbc2, #76fdfa);
      border-radius: 2px;
    }
    .con {
      width: 550px;
      .desc {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #444444;
        line-height: 30px;
      }
      .tip {
        margin-top: 5px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #4141ca;
        line-height: 30px;
      }
    }
  }
  .zytd {
    width: 544px;
    height: 250px;
    background: linear-gradient(22deg, #54c4ff, #1664ff);
    box-shadow: 1px 4px 10px 0px rgba(63, 163, 255, 0.52);
    border-radius: 30px;
    transform: translateY(-22px);
    position: relative;
    .tip {
      width: 280px;
      height: 60px;
      background: linear-gradient(90deg, #e7fbc2, #76fdfa);
      border-radius: 45px 30px 30px 0px;
      position: absolute;
      top: -30px;
      left: 0;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #4141ca;
      line-height: 60px;
      text-align: center;
    }
    .item-box {
      margin-top: 75px;
      width: 100%;
      flex-wrap: wrap;
      .item {
        width: 260px;
        padding-left: 28px;
        margin-bottom: 25px;
        .name {
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
          line-height: 24px;
          margin-left: 9px;
        }
      }
    }
  }
}
.yjs {
  width: 1199px;
  height: 260px;
  background: #ecf6ff;
  border-radius: 30px;
  position: relative;
  padding: 0 0 0 28px;
  .desc {
    width: 513px;
    height: 169px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #444444;
    line-height: 30px;
    margin-right: 66px;
    transform: translateY(-5px);
  }
  .shu {
    position: absolute;
    right: 26px;
    top: 45px;
    width: 4px;
    height: 180px;
    background: linear-gradient(0deg, #e7fbc2, #76fdfa);
    border-radius: 2px;
  }
}
.lijian {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #444444;
  line-height: 30px;
  width: 1180px;
}
.tedian {
  width: 688px;
  height: 54px;
  background: #e1faff;
  border-radius: 27px;
  margin: 47px 0 38px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #4141ca;
  line-height: 54px;
  text-align: center;
}
.xzsp {
  width: 100%;
  height: 860px;
  background: #3d3dc1;
  position: relative;

  .tit {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 40px;
    margin: 61px 0 31px;
  }
  .tip {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 18px;
  }
  .chart {
    margin: 0 0 0 135px;
    margin-top: -80px;
    z-index: 10;
  }
  .xzsp-img {
    width: 799px;
    margin: 22px 0 0 -100px;
  }
  .jjlx {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 30px;
    margin-left: -530px;
    margin-top: -90px;
    position: relative;
    &::after {
      content: '数据来源：职友网';
      position: absolute;
      right: 50px;
      top: -54px;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #c7c7ff;
      line-height: 30px;
    }
  }
  .jsx-box,
  .cpx-box {
    width: 1121px;
    height: 120px;
    background: #1414ac;
    border-radius: 10px;
    margin-top: 27px;
    position: relative;
    .jsx {
      width: 155px;
      height: 50px;
      background: linear-gradient(90deg, #e7fbc2, #76fdfa);
      border-radius: 10px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #1414ac;
      line-height: 50px;
      text-align: center;
      position: absolute;
      top: -7px;
      left: -10px;
    }
    .jsx-in {
      width: 900px;
      flex-wrap: wrap;
      .item {
        width: 200px;
        height: 34px;
        background: #86fdf2;
        border-radius: 17px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #00005a;
        line-height: 34px;
        text-align: center;
        margin: 7px 0;
      }
      .arrow {
        width: 51px;
        padding: 0 29px;
      }
    }
  }
  .cpx-box {
    height: 80px;
  }
}
.zpyq {
  width: 1200px;
  height: 260px;
  background: #4848e7;
  border-radius: 10px 10px 0px 0px;
  padding: 0 50px 0 37px;
  .tit {
    font-size: 30px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #ffffff;
    line-height: 30px;
    margin: 28px 0 30px;
  }
  .desc {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #fefefe;
    line-height: 30px;
  }
}
.jsjj {
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #4141ca;
  line-height: 30px;
  margin: 62px 0 38px;
}
.jj-box {
  width: 1100px;
  height: 328px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(72, 72, 231, 0.21);
  border-radius: 10px;
  overflow: hidden;
  .jieduan {
    height: 60px;
    .item {
      width: 50%;
      padding-left: 62px;
      .num {
        width: 83px;
        height: 30px;
        background: linear-gradient(90deg, #e7fbc2, #76fdfa);
        border-radius: 15px;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #4848e7;
        line-height: 30px;
        text-align: center;
      }
      .desc {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #3d3d3d;
        line-height: 60px;
        margin-left: 20px;
      }
    }
  }
  .jieduan1 {
    background: linear-gradient(-90deg, #54c4ff, #1664ff);
    box-shadow: 1px 4px 10px 0px rgba(63, 163, 255, 0.52);
    height: 74px;
    .desc {
      color: #fff !important;
    }
  }
}
.yfcj {
  width: 1143px;
  height: 48px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #505050;
  line-height: 30px;
}
.ybdw {
  width: 1108px;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #434343;
  line-height: 30px;
}
.xxypt {
  width: 100%;
  height: 612px;
  background: linear-gradient(90deg, #c6e7fb, #bbd7fb);
}
.kcdg {
  width: 100%;
  height: 800px;
  background: #0c1c4d;
  .dg-con {
    width: 1190px;
    height: 580px;
    background: #ffffff;
    border-radius: 10px;
    .jieduan {
      width: 280px;
      height: 580px;
      background: #2966e6;
      border-radius: 10px 0px 0px 10px;
      padding-top: 15px;
      .item {
        height: 88px;
        padding-left: 22px;
        cursor: pointer;
        &.act {
          width: 290px;
          height: 88px;
          transform: translateX(-8px);
          padding-left: 30px;
          background: linear-gradient(102deg, #54d1f9, #89ffe5);
          box-shadow: 2px 2px 2px 0px rgba(52, 69, 231, 0.27);
          border-radius: 10px 0px 0px 10px;
          .num {
            background: #fff;
            color: #0d43b6;
          }
          .name {
            font-weight: bold;
            color: #000000;
          }
        }
        .num {
          width: 68px;
          height: 24px;
          background: linear-gradient(90deg, #e7fbc2, #76fdfa);
          border-radius: 12px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #0d43b6;
          line-height: 24px;
          text-align: center;
        }
        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 30px;
          margin-top: 9px;
        }
      }
    }
    .con {
      width: 910px;
      height: 100%;
      padding: 29px 23px 29px 13px;
      overflow-y: auto;
      .mb-tit {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #0d43b6;
        line-height: 18px;
        margin-bottom: 13px;
      }
      .mb-desc {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #353535;
        line-height: 24px;
      }
      .c-name {
        width: 100%;
        height: 34px;
        background: #5f8be8;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        line-height: 34px;
        text-align: center;
        margin: 20px 0 3px;
      }
      .detail {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #232323;
        line-height: 24px;
        padding: 5px 14px;
        background: #e8f1fd;
        &:nth-of-type(2n + 1) {
          background: #f7f9fd;
        }
      }
    }
  }
}
</style>
